<script lang="ts">
    import dayjs from 'dayjs';
    import { VisibleDate } from '$saga/views/Tour/VisibleDates/types';
    import { selectedPrice } from '$saga/views/Tour/store';

    export let isClosedSales: boolean,
        bookableDates,
        visibleDates: VisibleDate[],
        dict;

    let selectedDate: string = '';

    $: {
        if (selectedDate !== '') {
            const selected = visibleDates.find(
                (date) =>
                    dayjs(date.date1.date).format('YYYY-MM-DD') ===
                    selectedDate,
            );
            if (selected) {
                $selectedPrice = {
                    originalPrice: selected.hasRebate
                        ? selected.priceWithCustomerCarbonContribution
                        : null,
                    rebateAmount:
                        selected.hasRebate && selected.rebateAmount
                            ? selected.rebateAmount
                            : null,
                    actualPrice:
                        selected.hasRebate &&
                        selected.rebatedPriceWithCustomerCarbonContribution
                            ? selected.rebatedPriceWithCustomerCarbonContribution
                            : selected.priceWithCustomerCarbonContribution,
                    // date: dayjs(selected.date1.date).format('YYYY-MM-DD'),
                };
            }
        } else {
            $selectedPrice = {
                originalPrice: null,
                rebateAmount: null,
                actualPrice: null,
            };
        }
    }
</script>

<div id="next-dates-gir" class="mx-auto mb-m mt-2xs">
    <span class="mb-2xs inline-block w-full">
        {dict.disponibles}
    </span>
    <select
        name="startDate"
        id="next-dates"
        data-travel-tour-target="nextDatesSelect"
        class="relative flex h-4xl min-h-2xl w-full border-border-neutral pl-l pr-3xl leading-6"
        disabled={isClosedSales || bookableDates.length === 0}
        required
        bind:value={selectedDate}
    >
        <option value="">{dict.choisir}</option>
        {#each visibleDates as date}
            <option
                value={dayjs(date.date1.date).format('YYYY-MM-DD').toString()}
                disabled={date.remaining_stock === 0}
                data-remaining-stock={date.remaining_stock}
            >
                {dayjs(date.date1.date).format('DD/MM/YYYY')} - {date.statusName}
            </option>
        {/each}
    </select>
</div>
